export default __webpack_public_path__ + "static/media/logo-capitaria-white.cd90d5eb.svg";